export class ProviderInvoiceRetentionModel {
  providerInvoiceRetentionId: number = 0;
  providerInvoiceId: number = 0;
  taxId: number = 0;
  baseValue: number = 0;
  taxRate: number = 0;
  swManual: boolean = false;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}
